import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.page`

export default defineMessages({
  cardholderAccountPageTitle: {
    id: `${scope}.cardholderAccountPageTitle`,
    defaultMessage: 'Cardholder account',
  },
  cardholderAccountSetupPageTitle: {
    id: `${scope}.cardholderAccountSetupPageTitle`,
    defaultMessage: 'Set up account',
  },
  cardholderAccountEditPageTitle: {
    id: `${scope}.cardholderAccountEditPageTitle`,
    defaultMessage: 'Edit account',
  },
  cardholderAccountVerifyPageTitle: {
    id: `${scope}.cardholderAccountVerifyPageTitle`,
    defaultMessage: 'Verify cardholder',
  },
  cardManagementPageTitle: {
    id: `${scope}.cardManagementPageTitle`,
    defaultMessage: 'Manage cards',
  },
  transactionReconciliationPageTitle: {
    id: `${scope}.transactionReconciliationPageTitle`,
    defaultMessage: 'Spending card reconciliation',
  },
  cardManagementDetailsPageTitle: {
    id: `${scope}.cardManagementDetailsPageTitle`,
    defaultMessage: 'Card details',
  },
  requestVirtualCardPageTitle: {
    id: `${scope}.requestVirtualCardPageTitle`,
    defaultMessage: 'Request virtual card',
  },
  virtualCardsPageTitle: {
    id: `${scope}.virtualCardsPageTitle`,
    defaultMessage: 'Virtual cards',
  },
})
